<script>
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724855';
    import { onMount } from 'svelte';

    wyvr: {
        render: 'hydrate';
        loading: 'lazy';
    }

    export let product = undefined;
    export let title = undefined;
    export let options;

    const id = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOjE2NCwianRpIjoiNTQ1M2RkMDAtYTMyZi00MGY0LWJlZDgtZGZiMTc1MzJmMDkyIiwic2NvcGVzIjpbInZwciIsInZwcyIsInZwYyJdfQ.M1zLPHdwbYfj4maqEinQbaDcV2ghiBph6HFLMe8v57yUilnQQwmIl58wwzBbbd2isapnRiuHnP0ewxLrvPcjxnf7pwnbmDa2IExNAZVj7egrarOs3Hpr31Q_5XKJHqXtttFEP9I5_K1w_7hqhM_ilehL3zPjT57ZVoUx8T6MIeuzagz3HBFTimcV9333iM9o3LeHgIH-NFlsBdAMMDYKU2XrEeHSv1Pwd_qOYvspR4N8hz3CIBJ9ZmC-NeUpvbsBIFzpcWjPpd5AyU0ZPUt8ZLkmzNQiWe65mqjCAtI_Qv98vVLqcHP1083u7A0CVxEg0HF6KcPcTYLB7JrVllqEig";

    $: product_id = get_attribute_value(product, 'sku');
    $: campaign_type = options?.campaignType ?? 'VPR';
    $: mode = options?.mode ?? 'grid';
    $: internal_title = title || window.__('recommendations.title');

    onMount(() => {
        if (!window.vviinn_widget_installed) {
            const tag = document.createElement('script');
            tag.src = 'https://cdn.jsdelivr.net/npm/vviinn-widgets@2.29.0/www/build/vviinn-widgets.esm.js';
            tag.type = 'module';
            document.querySelector('head').appendChild(tag);
            window.vviinn_widget_installed = true;
        }
    });
</script>

{#if id}
    <vviinn-vpr-widget
        token={id}
        product-id={product_id}
        campaign-type={campaign_type}
        {mode}
        block-title={internal_title}
    />
{/if}
